export default "__VITE_ASSET__C2X4uAes__"